import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class LookUp {
  // 应收抬头列表
  static getAccountsReceivableHeaderList(options) {
    let url = `/zwy/api/cb/logistics/project/receivable/bill/head/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增应收抬头
  static postAddAccountsReceivableHeader(data) {
    const url = `/zwy/api/cb/logistics/project/save/receivable/bill/head`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑应收抬头
  static postUpdateAccountsReceivableHeader(id, data) {
    const url = `/zwy/api/cb/logistics/project/update/receivable/bill/head/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除应收抬头
  static postDelAccountsReceivableHeader(id) {
    const url = `/zwy/api/cb/logistics/project/delete/receivable/bill/head/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开启/关闭应收抬头
  static postUpdateAccountsReceivableHeaderStatus(id) {
    const url = `/zwy/api/cb/logistics/project/update/status/receivable/bill/head/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }


  // 应付抬头列表
  static getCopingWithHeaderList(options) {
    let url = `/zwy/api/cb/logistics/project/payable/bill/head/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增应付抬头
  static postAddCopingWithHeader(data) {
    const url = `/zwy/api/cb/logistics/project/save/payable/bill/head`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑应付抬头
  static postUpdateCopingWithHeader(id, data) {
    const url = `/zwy/api/cb/logistics/project/update/payable/bill/head/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除应付抬头
  static postDelCopingWithHeader(id) {
    const url = `/zwy/api/cb/logistics/project/delete/payable/bill/head/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开启/关闭应付抬头
  static postUpdateCopingWithHeaderStatus(id) {
    const url = `/zwy/api/cb/logistics/project/update/status/payable/bill/head/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default LookUp;
